const Logo = (props) => (
  <img
    alt={props.alt}
    src={props.src}
    {...props}
    style={{
      height: '45px',
      background: '#fff',
      borderRadius: '10px',
      padding: '5px',
      ...(props.style || {})
    }}
  />
);

export default Logo;
